import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import React from 'react';
import { getEnvironment, getVersion } from 'app/functions/environment';

let client;

export const getNotifier = () => {
    if (!client) {
        const bugsnagClient = bugsnag({
            apiKey: process.env.SEARCH_BUGSNAG_TOKEN,
            appVersion: getVersion(),
            releaseStage: getEnvironment(),
            autoNotify: false, // Will not notify on window related exceptions
        });
        bugsnagClient.use(bugsnagReact, React);

        client = bugsnagClient;
    }

    return client;
};
